

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/19e1ae871b27e79d86366822ce3eb7e6/f09671dcd844158d8753d9b85b14be0e.png" 
                alt="A&R Electric Logo" 
                className="h-24 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Professional residential electrical services with a focus on quality, safety, and customer satisfaction. 
              Licensed, insured, and committed to excellence.
            </p>
            <div className="flex space-x-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-facebook-fill text-xl hover:text-yellow-400 transition-colors cursor-pointer"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-instagram-line text-xl hover:text-yellow-400 transition-colors cursor-pointer"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-linkedin-fill text-xl hover:text-yellow-400 transition-colors cursor-pointer"></i>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#services" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">Our Services</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#projects" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">Recent Projects</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-yellow-400"></i>
                </div>
                <span className="text-gray-300">(602) 803-5076</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-yellow-400"></i>
                </div>
                <span className="text-gray-300">info@arelectric.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-yellow-400"></i>
                </div>
                <span className="text-gray-300">Serving Greater Metro Area<br />Licensed & Insured</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 A&R Electric. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}

